import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import StudentFormService from "../../../services/KangarooServices/StudentFormService";
import Select from "react-select";
import DestinationService from "../../../services/KangarooServices/DestinationService";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import BranchService from "../../../services/KangarooServices/BranchService";

const StudentForm = ({ toggle }) => {
  const { id } = useParams();
  const [destinationData, setDestinationData] = useState([]);
  const [branchData, setBranchData] = useState([]);
  const [detailData, setDetailData] = useState();
  const navigate = useNavigate();
  const fetchDestination = async () => {
    try {
      const response = await DestinationService.getList();
      setDestinationData(response);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchDestination();
  }, []);
  const fetchDetail = async () => {
    try {
      const response = await StudentFormService.getDetail(id);
      setDetailData(response);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchDetail();
  }, [id]);

  useEffect(() => {
    const fetchBranches = async () => {
      try {
        const result = await BranchService.getList({
          search: "",
          page: 1,
          pageSize: 1000,
        });
        // API returns an object with 'items' array
        setBranchData(result?.items || []);
        console.log("Fetched Branch Data:", result);
      } catch (error) {
        console.log(error);
        setBranchData([]); // Set empty array on error
      }
    };

    fetchBranches();
  }, []);
  console.log("BRANCH DATA", branchData);

  const destinationOptions =
    destinationData?.map((type) => ({
      value: type.id,
      label: type.name,
    })) || [];

  const branchOptions =
    Array.isArray(branchData)
      ? branchData.map((branch) => ({
          value: branch.id,
          label: branch.officeName, // Use officeName from API response
        }))
      : [];

  const initialPreferredCountry =
    destinationOptions.find(
      (opt) => opt.value === detailData?.preferredCountryId
    )?.value || null;

  const initialPreferredBranch =
    branchOptions.find(
      (opt) => opt.value === detailData?.preferedBranchId
    )?.value || null;

  const statusOptions = [
    { value: 1, label: "Success" },
    { value: 2, label: "Contacted" },
    { value: 3, label: "CallBackRequested" },
    { value: 4, label: "NotInterested" },
    { value: 5, label: "InvalidContact" },
    { value: 6, label: "CallNotAnswered" },
    { value: 7, label: "Failed" },
    { value: 8, label: "InTouchThroughOtherMeans" },
    { value: 9, label: "New"},
  ];
  const initialStatusValue =
    statusOptions.find((opt) => opt.label === detailData?.status)?.value || 1; // fallback to 1

  const formik = useFormik({
    initialValues: {
      fullName: detailData?.fullName || "",
      email: detailData?.email || "",
      phone: detailData?.phone || "",
      nationality: detailData?.nationality || "",
      currentQualification: detailData?.currentQualification || "",
      intendedLevel: detailData?.intendedLevel || "",
      preferredCountryId: initialPreferredCountry || "",
      preferedBranchId: initialPreferredBranch || "",
      preferredCourse: detailData?.preferredCourse || "",
      budgetRange: detailData?.budgetRange || "",
      englishLevel: detailData?.englishLevel || "",
      workExperienceYears: detailData?.workExperienceYears || 0,
      message: detailData?.message || "",
      consent: detailData?.consent || false,
      leadSource: detailData?.leadSource || "",
      status: initialStatusValue,
      // applyDate: detailData?.applyDate || "",
    },
    enableReinitialize: true,
    onSubmit: async (values) => {
      try {
        if (id) {
          const response = await StudentFormService.update(id, values);
          toast.success("Student forms updated.");
        } else {
          const response = await StudentFormService.create(values);
          toast.success("Student forms created.");
        }
        navigate("/student-forms");
      } catch (error) {
        console.log(error);
      }
    },
  });

  return (
    <Container fluid>
      <div className="page-content">
        <BreadCrumb
          title="Student Form"
          pageTitle="Page"
          breadcrumbItems={[{ title: "Back to List", link: "/student-forms" }]}
        />
        
        <Form onSubmit={formik.handleSubmit}>
          <Row>
          <div className="hstack gap-2 justify-content-end mt-4 mb-3">
            <Button color="success" type="submit">
              {id ? "Update" : "Add"} Application
            </Button>
            <Button color="danger" onClick={() => {
    formik.resetForm();
    if (toggle) {
      toggle();
    } else {
      navigate("/student-forms");
    }
  }}>
              Cancel
            </Button>
          </div>
        </Row>
          {/* <div className="text-center mb-4">
            <div className="position-relative d-inline-block">
              <div className="avatar-lg">
                <img
                  src={MultiUser}
                  alt=""
                  className="rounded-circle avatar-md object-fit-cover"
                />
              </div>
            </div>
          </div> */}

          <Row>
            {/* Left Card */}
            <Col md={6}>
              <Card className="p-3 mb-3">
                <CardBody>
                  <h5 className="mb-3">Personal Info</h5>

                  <FormGroup className="mb-3">
                    <Label>Full Name</Label>
                    <Input
                      name="fullName"
                      value={formik.values.fullName}
                      onChange={formik.handleChange}
                      placeholder="Enter full name"
                      required
                    />
                  </FormGroup>

                  <FormGroup className="mb-3">
                    <Label>Email</Label>
                    <Input
                      type="email"
                      name="email"
                      value={formik.values.email}
                      onChange={formik.handleChange}
                      placeholder="Enter email"
                      required
                    />
                  </FormGroup>

                  <FormGroup className="mb-3">
                    <Label>Phone</Label>
                    <Input
                      type="text"
                      name="phone"
                      value={formik.values.phone}
                      onChange={formik.handleChange}
                      placeholder="Enter phone number"
                      required
                    />
                  </FormGroup>

                  <FormGroup className="mb-3">
                    <Label>Nationality</Label>
                    <Input
                      name="nationality"
                      value={formik.values.nationality}
                      onChange={formik.handleChange}
                      placeholder="Enter nationality"
                    />
                  </FormGroup>

                  <FormGroup className="mb-3">
                    <Label>Current Qualification</Label>
                    <Input
                      name="currentQualification"
                      value={formik.values.currentQualification}
                      onChange={formik.handleChange}
                      placeholder="Enter qualification"
                    />
                  </FormGroup>

                  <FormGroup className="mb-3">
                    <Label>Intended Level</Label>
                    <Input
                      name="intendedLevel"
                      value={formik.values.intendedLevel}
                      onChange={formik.handleChange}
                      placeholder="Enter intended level"
                    />
                  </FormGroup>

                  <FormGroup className="mb-3">
                    <Label>Preferred Country</Label>
                    <Select
                      name="preferredCountryId"
                      options={destinationOptions}
                      value={destinationOptions.find(
                        (opt) => opt.value === formik.values.preferredCountryId
                      )}
                      onChange={(selected) =>
                        formik.setFieldValue(
                          "preferredCountryId",
                          selected ? selected.value : null
                        )
                      }
                    />
                  </FormGroup>

                  <FormGroup className="mb-3">
                    <Label>Preferred Branch</Label>
                    <Select
                      name="preferedBranchId"
                      options={branchOptions}
                      value={branchOptions.find(
                        (opt) => opt.value === formik.values.preferedBranchId
                      )}
                      onChange={(selected) =>
                        formik.setFieldValue(
                          "preferedBranchId",
                          selected ? selected.value : null
                        )
                      }
                    />
                  </FormGroup>

                  <FormGroup className="mb-3">
                    <Label>Status</Label>
                    <Select
                      options={statusOptions}
                      value={statusOptions.find(
                        (opt) => opt.value === formik.values.status
                      )}
                      onChange={(selected) =>
                        formik.setFieldValue("status", selected.value)
                      }
                    />
                  </FormGroup>
                </CardBody>
              </Card>
            </Col>

            {/* Right Card */}
            <Col md={6}>
              <Card className="p-3 mb-3">
                <CardBody>
                  <h5 className="mb-3">Application Details</h5>

                  <FormGroup className="mb-3">
                    <Label>Preferred Course</Label>
                    <Input
                      name="preferredCourse"
                      value={formik.values.preferredCourse}
                      onChange={formik.handleChange}
                      placeholder="Enter course"
                    />
                  </FormGroup>

                  <FormGroup className="mb-3">
                    <Label>Budget Range</Label>
                    <Input
                      name="budgetRange"
                      value={formik.values.budgetRange}
                      onChange={formik.handleChange}
                      placeholder="Enter budget range"
                    />
                  </FormGroup>

                  <FormGroup className="mb-3">
                    <Label>English Level</Label>
                    <Input
                      name="englishLevel"
                      value={formik.values.englishLevel}
                      onChange={formik.handleChange}
                      placeholder="Enter English level"
                    />
                  </FormGroup>

                  <FormGroup className="mb-3">
                    <Label>Work Experience (Years)</Label>
                    <Input
                      type="number"
                      name="workExperienceYears"
                      value={formik.values.workExperienceYears}
                      onChange={formik.handleChange}
                      placeholder="Enter years of experience"
                    />
                  </FormGroup>

                  {/* <FormGroup className="mb-3">
                    <Label>Apply Date</Label>
                    <Input
                      type="date"
                      name="applyDate"
                      value={formik.values.applyDate}
                      onChange={formik.handleChange}
                    />
                  </FormGroup> */}

                  <FormGroup className="mb-3">
                    <Input
                      type="checkbox"
                      name="consent"
                      checked={formik.values.consent}
                      onChange={formik.handleChange}
                    />
                    <Label className="ms-2 mb-0">I give my consent</Label>
                  </FormGroup>

                  <FormGroup className="mb-3">
                    <Label>Message</Label>
                    <Input
                      type="textarea"
                      name="message"
                      value={formik.values.message}
                      onChange={formik.handleChange}
                      placeholder="Enter message"
                    />
                  </FormGroup>

                  <FormGroup className="mb-3">
                    <Label>Lead Source</Label>
                    <Input
                      name="leadSource"
                      value={formik.values.leadSource}
                      onChange={formik.handleChange}
                      placeholder="Enter lead source"
                    />
                  </FormGroup>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Form>
      </div>
    </Container>
  );
};

export default StudentForm;